// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
::after,
::before {
    box-sizing: border-box;
}
html {
    font-family: sans-serif;
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -ms-overflow-style: scrollbar;
    -webkit-tap-highlight-color: transparent;
}
@-ms-viewport {
    /*width: device-width;*/
}
article,
aside,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section {
    display: block;
}
body {
    margin: 0;
    font-family: "Inter", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif,
        'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    background-color: #fff;
}
[tabindex='-1']:focus {
    outline: 0 !important;
}
hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
}
h1,
h2,
h3,
h4,
h5,
h6 {
    margin-top: 0;
    margin-bottom: 0.5rem;
}
p {
    margin-top: 0;
    margin-bottom: 1rem;
}
abbr[data-original-title],
abbr[title] {
    text-decoration: underline;
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
    cursor: help;
    border-bottom: 0;
}
address {
    margin-bottom: 1rem;
    font-style: normal;
    line-height: inherit;
}
dl,
ol,
ul {
    margin-top: 0;
    margin-bottom: 1rem;
}
ol ol,
ol ul,
ul ol,
ul ul {
    margin-bottom: 0;
}
dt {
    font-weight: 700;
}
dd {
    margin-bottom: 0.5rem;
    margin-left: 0;
}
blockquote {
    margin: 0 0 1rem;
}
dfn {
    font-style: italic;
}
b,
strong {
    font-weight: bolder;
}
small {
    font-size: 80%;
}
sub,
sup {
    position: relative;
    font-size: 75%;
    line-height: 0;
    vertical-align: baseline;
}
sub {
    bottom: -0.25em;
}
sup {
    top: -0.5em;
}
a {
    color: #007bff;
    text-decoration: none;
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
}
a:hover {
    color: #0056b3;
    text-decoration: none;
}
a:not([href]):not([tabindex]) {
    color: inherit;
    text-decoration: none;
}
a:not([href]):not([tabindex]):focus,
a:not([href]):not([tabindex]):hover {
    color: inherit;
    text-decoration: none;
}
a:not([href]):not([tabindex]):focus {
    outline: 0;
}
code,
kbd,
pre,
samp {
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
    font-size: 1em;
}
pre {
    margin-top: 0;
    margin-bottom: 1rem;
    overflow: auto;
    -ms-overflow-style: scrollbar;
}
figure {
    margin: 0 0 1rem;
}
img {
    vertical-align: middle;
    border-style: none;
}
svg {
    overflow: hidden;
    vertical-align: middle;
}
table {
    border-collapse: collapse;
}
caption {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    color: #6c757d;
    text-align: left;
    caption-side: bottom;
}
th {
    text-align: inherit;
}
label {
    display: inline-block;
    margin-bottom: 0.5rem;
}
button {
    border-radius: 0;
}
button:focus {
    outline: 1px dotted;
    outline: 5px auto -webkit-focus-ring-color;
}
button,
input,
optgroup,
select,
textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
}
button,
input {
    overflow: visible;
}
button,
select {
    text-transform: none;
}
[type='reset'],
[type='submit'],
button,
html [type='button'] {
    -webkit-appearance: button;
}
[type='button']::-moz-focus-inner,
[type='reset']::-moz-focus-inner,
[type='submit']::-moz-focus-inner,
button::-moz-focus-inner {
    padding: 0;
    border-style: none;
}
input[type='checkbox'],
input[type='radio'] {
    box-sizing: border-box;
    padding: 0;
}
input[type='date'],
input[type='datetime-local'],
input[type='month'],
input[type='time'] {
    -webkit-appearance: listbox;
}
textarea {
    overflow: auto;
    resize: vertical;
}
fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
}
legend {
    display: block;
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin-bottom: 0.5rem;
    font-size: 1.5rem;
    line-height: inherit;
    color: inherit;
    white-space: normal;
}
progress {
    vertical-align: baseline;
}
[type='number']::-webkit-inner-spin-button,
[type='number']::-webkit-outer-spin-button {
    height: auto;
}
[type='search'] {
    outline-offset: -2px;
    -webkit-appearance: none;
}
[type='search']::-webkit-search-cancel-button,
[type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
}
::-webkit-file-upload-button {
    font: inherit;
    -webkit-appearance: button;
}
output {
    display: inline-block;
}
summary {
    display: list-item;
    cursor: pointer;
}
template {
    display: none;
}
[hidden] {
    display: none !important;
}

.w-max {
    width: 1152px;
}

.w-max-strict {
    width: 1152px;
    min-width: 1152px;
    max-width: 1152px;
}

.card-response {
    width: 270px;
    height: 380px;
    min-width: 270px;
    min-height: 380px;
    max-width: 270px;
    max-height: 380px;
}

.card-grid-response {
    display: grid;
    grid-template-columns: repeat(4, 270px);
    gap: 24px;
}
/*Глобальные стили для кнопок в компетишене, которые просила Алёна) */
.comps-btn_white {
    font-family: "Inter";
    padding: 12px 32px 12px 24px;
    border: 1px solid #B6B6B5;
    border-radius: 3px;
    height: 48px;
    display: flex;
    place-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: transparent;
    transition: border 0.5s;
    white-space: pre;
}

.comps-btn_black {
    font-family: "Inter";
    padding: 12px 32px 12px 24px;
    color: #fff;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    border: 1px solid transparent;
    border-radius: 3px;
    height: 48px;
    display: flex;
    place-items: center;
    justify-content: center;
    cursor: pointer;
    letter-spacing: -0.02em;
    background-color: #151514;
    transition: background-color 0.5s;
    white-space: pre;
}

.comps-btn_white > * {
    color: #151514;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.02em;
}

.comps-btn_black > * {
    color: #fff;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.02em;
}

.comps-btn_black:hover, 
.comps-btn_black:focus,
.comps-btn_black:active {
    background-color: #1F1F1F;
    transition: background-color 0.5s;
}

.comps-btn_white:hover,
.comps-btn_white:focus,
.comps-btn_white:active {
    border: 1px solid #8E9193;
    transition: border 0.5s;
}

@media (max-width: 1280px) {
    .w-max {
        width: 940px;
    }

    .w-max-strict {
        width: 940px;
        min-width: 940px;
        max-width: 940px;
    }

    .card-response {
        width: 221.25px;
        height: 311.38px;
        min-width: 221.25px;
        min-height: 311.38px;
        max-width: 221.25px;
        max-height: 311.38px;
    }

    .card-grid-response {
        display: grid;
        grid-template-columns: repeat(4, 221.25px);
        gap: 19.6px;
    }
}

::-webkit-scrollbar {
    width: 10px; /* ширина scrollbar */
    height: 10px;
}
::-webkit-scrollbar-track {
    background: transparent; /* цвет дорожки */
}
::-webkit-scrollbar-thumb {
    border-radius: 3px; /* закругления плашки */
    background: rgba(0, 0, 0, 0.596);
    border: 1px solid rgba(254, 254, 254, 0.13);
}

.onlines-font {
    font-family: 'Space Grotesk', sans-serif !important;
}

.onlines-desc {
    font-family: 'Montserrat' !important;
}
`, "",{"version":3,"sources":["webpack://./src/core/starter/styles.css"],"names":[],"mappings":"AAAA;;;IAGI,sBAAsB;AAC1B;AACA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,8BAA8B;IAC9B,0BAA0B;IAC1B,6BAA6B;IAC7B,wCAAwC;AAC5C;AACA;IACI,uBAAuB;AAC3B;AACA;;;;;;;;;;IAUI,cAAc;AAClB;AACA;IACI,SAAS;IACT;oFACgF;IAChF,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,uBAAuB;IACvB,SAAS;IACT,iBAAiB;AACrB;AACA;;;;;;IAMI,aAAa;IACb,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;;IAEI,0BAA0B;IAC1B,yCAAyC;IACzC,iCAAiC;IACjC,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;;;IAGI,aAAa;IACb,mBAAmB;AACvB;AACA;;;;IAII,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;;IAEI,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;;IAEI,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,wBAAwB;AAC5B;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,6BAA6B;IAC7B,qCAAqC;AACzC;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;;IAEI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,UAAU;AACd;AACA;;;;IAII,iGAAiG;IACjG,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,6BAA6B;AACjC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,0CAA0C;AAC9C;AACA;;;;;IAKI,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;;IAEI,iBAAiB;AACrB;AACA;;IAEI,oBAAoB;AACxB;AACA;;;;IAII,0BAA0B;AAC9B;AACA;;;;IAII,UAAU;IACV,kBAAkB;AACtB;AACA;;IAEI,sBAAsB;IACtB,UAAU;AACd;AACA;;;;IAII,2BAA2B;AAC/B;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,UAAU;IACV,SAAS;IACT,SAAS;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,UAAU;IACV,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,wBAAwB;AAC5B;AACA;;IAEI,YAAY;AAChB;AACA;IACI,oBAAoB;IACpB,wBAAwB;AAC5B;AACA;;IAEI,wBAAwB;AAC5B;AACA;IACI,aAAa;IACb,0BAA0B;AAC9B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uCAAuC;IACvC,SAAS;AACb;AACA,qEAAqE;AACrE;IACI,oBAAoB;IACpB,4BAA4B;IAC5B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,6BAA6B;IAC7B,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,4BAA4B;IAC5B,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;;;IAGI,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;;;IAGI,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,oBAAoB;QACpB,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,0CAA0C;QAC1C,WAAW;IACf;AACJ;;AAEA;IACI,WAAW,EAAE,qBAAqB;IAClC,YAAY;AAChB;AACA;IACI,uBAAuB,EAAE,iBAAiB;AAC9C;AACA;IACI,kBAAkB,EAAE,uBAAuB;IAC3C,gCAAgC;IAChC,2CAA2C;AAC/C;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":["*,\n::after,\n::before {\n    box-sizing: border-box;\n}\nhtml {\n    font-family: sans-serif;\n    line-height: 1.15;\n    -webkit-text-size-adjust: 100%;\n    -ms-text-size-adjust: 100%;\n    -ms-overflow-style: scrollbar;\n    -webkit-tap-highlight-color: transparent;\n}\n@-ms-viewport {\n    /*width: device-width;*/\n}\narticle,\naside,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nnav,\nsection {\n    display: block;\n}\nbody {\n    margin: 0;\n    font-family: \"Inter\", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif,\n        'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #212529;\n    text-align: left;\n    background-color: #fff;\n}\n[tabindex='-1']:focus {\n    outline: 0 !important;\n}\nhr {\n    box-sizing: content-box;\n    height: 0;\n    overflow: visible;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    margin-top: 0;\n    margin-bottom: 0.5rem;\n}\np {\n    margin-top: 0;\n    margin-bottom: 1rem;\n}\nabbr[data-original-title],\nabbr[title] {\n    text-decoration: underline;\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n    cursor: help;\n    border-bottom: 0;\n}\naddress {\n    margin-bottom: 1rem;\n    font-style: normal;\n    line-height: inherit;\n}\ndl,\nol,\nul {\n    margin-top: 0;\n    margin-bottom: 1rem;\n}\nol ol,\nol ul,\nul ol,\nul ul {\n    margin-bottom: 0;\n}\ndt {\n    font-weight: 700;\n}\ndd {\n    margin-bottom: 0.5rem;\n    margin-left: 0;\n}\nblockquote {\n    margin: 0 0 1rem;\n}\ndfn {\n    font-style: italic;\n}\nb,\nstrong {\n    font-weight: bolder;\n}\nsmall {\n    font-size: 80%;\n}\nsub,\nsup {\n    position: relative;\n    font-size: 75%;\n    line-height: 0;\n    vertical-align: baseline;\n}\nsub {\n    bottom: -0.25em;\n}\nsup {\n    top: -0.5em;\n}\na {\n    color: #007bff;\n    text-decoration: none;\n    background-color: transparent;\n    -webkit-text-decoration-skip: objects;\n}\na:hover {\n    color: #0056b3;\n    text-decoration: none;\n}\na:not([href]):not([tabindex]) {\n    color: inherit;\n    text-decoration: none;\n}\na:not([href]):not([tabindex]):focus,\na:not([href]):not([tabindex]):hover {\n    color: inherit;\n    text-decoration: none;\n}\na:not([href]):not([tabindex]):focus {\n    outline: 0;\n}\ncode,\nkbd,\npre,\nsamp {\n    font-family: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;\n    font-size: 1em;\n}\npre {\n    margin-top: 0;\n    margin-bottom: 1rem;\n    overflow: auto;\n    -ms-overflow-style: scrollbar;\n}\nfigure {\n    margin: 0 0 1rem;\n}\nimg {\n    vertical-align: middle;\n    border-style: none;\n}\nsvg {\n    overflow: hidden;\n    vertical-align: middle;\n}\ntable {\n    border-collapse: collapse;\n}\ncaption {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n    color: #6c757d;\n    text-align: left;\n    caption-side: bottom;\n}\nth {\n    text-align: inherit;\n}\nlabel {\n    display: inline-block;\n    margin-bottom: 0.5rem;\n}\nbutton {\n    border-radius: 0;\n}\nbutton:focus {\n    outline: 1px dotted;\n    outline: 5px auto -webkit-focus-ring-color;\n}\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n    margin: 0;\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit;\n}\nbutton,\ninput {\n    overflow: visible;\n}\nbutton,\nselect {\n    text-transform: none;\n}\n[type='reset'],\n[type='submit'],\nbutton,\nhtml [type='button'] {\n    -webkit-appearance: button;\n}\n[type='button']::-moz-focus-inner,\n[type='reset']::-moz-focus-inner,\n[type='submit']::-moz-focus-inner,\nbutton::-moz-focus-inner {\n    padding: 0;\n    border-style: none;\n}\ninput[type='checkbox'],\ninput[type='radio'] {\n    box-sizing: border-box;\n    padding: 0;\n}\ninput[type='date'],\ninput[type='datetime-local'],\ninput[type='month'],\ninput[type='time'] {\n    -webkit-appearance: listbox;\n}\ntextarea {\n    overflow: auto;\n    resize: vertical;\n}\nfieldset {\n    min-width: 0;\n    padding: 0;\n    margin: 0;\n    border: 0;\n}\nlegend {\n    display: block;\n    width: 100%;\n    max-width: 100%;\n    padding: 0;\n    margin-bottom: 0.5rem;\n    font-size: 1.5rem;\n    line-height: inherit;\n    color: inherit;\n    white-space: normal;\n}\nprogress {\n    vertical-align: baseline;\n}\n[type='number']::-webkit-inner-spin-button,\n[type='number']::-webkit-outer-spin-button {\n    height: auto;\n}\n[type='search'] {\n    outline-offset: -2px;\n    -webkit-appearance: none;\n}\n[type='search']::-webkit-search-cancel-button,\n[type='search']::-webkit-search-decoration {\n    -webkit-appearance: none;\n}\n::-webkit-file-upload-button {\n    font: inherit;\n    -webkit-appearance: button;\n}\noutput {\n    display: inline-block;\n}\nsummary {\n    display: list-item;\n    cursor: pointer;\n}\ntemplate {\n    display: none;\n}\n[hidden] {\n    display: none !important;\n}\n\n.w-max {\n    width: 1152px;\n}\n\n.w-max-strict {\n    width: 1152px;\n    min-width: 1152px;\n    max-width: 1152px;\n}\n\n.card-response {\n    width: 270px;\n    height: 380px;\n    min-width: 270px;\n    min-height: 380px;\n    max-width: 270px;\n    max-height: 380px;\n}\n\n.card-grid-response {\n    display: grid;\n    grid-template-columns: repeat(4, 270px);\n    gap: 24px;\n}\n/*Глобальные стили для кнопок в компетишене, которые просила Алёна) */\n.comps-btn_white {\n    font-family: \"Inter\";\n    padding: 12px 32px 12px 24px;\n    border: 1px solid #B6B6B5;\n    border-radius: 3px;\n    height: 48px;\n    display: flex;\n    place-items: center;\n    justify-content: center;\n    cursor: pointer;\n    background-color: transparent;\n    transition: border 0.5s;\n    white-space: pre;\n}\n\n.comps-btn_black {\n    font-family: \"Inter\";\n    padding: 12px 32px 12px 24px;\n    color: #fff;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    border: 1px solid transparent;\n    border-radius: 3px;\n    height: 48px;\n    display: flex;\n    place-items: center;\n    justify-content: center;\n    cursor: pointer;\n    letter-spacing: -0.02em;\n    background-color: #151514;\n    transition: background-color 0.5s;\n    white-space: pre;\n}\n\n.comps-btn_white > * {\n    color: #151514;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: -0.02em;\n}\n\n.comps-btn_black > * {\n    color: #fff;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: -0.02em;\n}\n\n.comps-btn_black:hover, \n.comps-btn_black:focus,\n.comps-btn_black:active {\n    background-color: #1F1F1F;\n    transition: background-color 0.5s;\n}\n\n.comps-btn_white:hover,\n.comps-btn_white:focus,\n.comps-btn_white:active {\n    border: 1px solid #8E9193;\n    transition: border 0.5s;\n}\n\n@media (max-width: 1280px) {\n    .w-max {\n        width: 940px;\n    }\n\n    .w-max-strict {\n        width: 940px;\n        min-width: 940px;\n        max-width: 940px;\n    }\n\n    .card-response {\n        width: 221.25px;\n        height: 311.38px;\n        min-width: 221.25px;\n        min-height: 311.38px;\n        max-width: 221.25px;\n        max-height: 311.38px;\n    }\n\n    .card-grid-response {\n        display: grid;\n        grid-template-columns: repeat(4, 221.25px);\n        gap: 19.6px;\n    }\n}\n\n::-webkit-scrollbar {\n    width: 10px; /* ширина scrollbar */\n    height: 10px;\n}\n::-webkit-scrollbar-track {\n    background: transparent; /* цвет дорожки */\n}\n::-webkit-scrollbar-thumb {\n    border-radius: 3px; /* закругления плашки */\n    background: rgba(0, 0, 0, 0.596);\n    border: 1px solid rgba(254, 254, 254, 0.13);\n}\n\n.onlines-font {\n    font-family: 'Space Grotesk', sans-serif !important;\n}\n\n.onlines-desc {\n    font-family: 'Montserrat' !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
::after,
::before {
    box-sizing: border-box;
}
html {
    font-family: sans-serif;
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -ms-overflow-style: scrollbar;
    -webkit-tap-highlight-color: transparent;
}
@-ms-viewport {
    /*width: device-width;*/
}
article,
aside,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section {
    display: block;
}
body {
    margin: 0;
    font-family: "Inter", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif,
        'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    background-color: #fff;
}
[tabindex='-1']:focus {
    outline: 0 !important;
}
hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
}
h1,
h2,
h3,
h4,
h5,
h6 {
    margin-top: 0;
    margin-bottom: 0.5rem;
}
p {
    margin-top: 0;
    margin-bottom: 1rem;
}
abbr[data-original-title],
abbr[title] {
    text-decoration: underline;
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
    cursor: help;
    border-bottom: 0;
}
address {
    margin-bottom: 1rem;
    font-style: normal;
    line-height: inherit;
}
dl,
ol,
ul {
    margin-top: 0;
    margin-bottom: 1rem;
}
ol ol,
ol ul,
ul ol,
ul ul {
    margin-bottom: 0;
}
dt {
    font-weight: 700;
}
dd {
    margin-bottom: 0.5rem;
    margin-left: 0;
}
blockquote {
    margin: 0 0 1rem;
}
dfn {
    font-style: italic;
}
b,
strong {
    font-weight: bolder;
}
small {
    font-size: 80%;
}
sub,
sup {
    position: relative;
    font-size: 75%;
    line-height: 0;
    vertical-align: baseline;
}
sub {
    bottom: -0.25em;
}
sup {
    top: -0.5em;
}
a {
    color: #007bff;
    text-decoration: none;
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
}
a:hover {
    color: #0056b3;
    text-decoration: none;
}
a:not([href]):not([tabindex]) {
    color: inherit;
    text-decoration: none;
}
a:not([href]):not([tabindex]):focus,
a:not([href]):not([tabindex]):hover {
    color: inherit;
    text-decoration: none;
}
a:not([href]):not([tabindex]):focus {
    outline: 0;
}
code,
kbd,
pre,
samp {
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
    font-size: 1em;
}
pre {
    margin-top: 0;
    margin-bottom: 1rem;
    overflow: auto;
    -ms-overflow-style: scrollbar;
}
figure {
    margin: 0 0 1rem;
}
img {
    vertical-align: middle;
    border-style: none;
}
svg {
    overflow: hidden;
    vertical-align: middle;
}
table {
    border-collapse: collapse;
}
caption {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    color: #6c757d;
    text-align: left;
    caption-side: bottom;
}
th {
    text-align: inherit;
}
label {
    display: inline-block;
    margin-bottom: 0.5rem;
}
button {
    border-radius: 0;
}
button:focus {
    outline: 1px dotted;
    outline: 5px auto -webkit-focus-ring-color;
}
button,
input,
optgroup,
select,
textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
}
button,
input {
    overflow: visible;
}
button,
select {
    text-transform: none;
}
[type='reset'],
[type='submit'],
button,
html [type='button'] {
    -webkit-appearance: button;
}
[type='button']::-moz-focus-inner,
[type='reset']::-moz-focus-inner,
[type='submit']::-moz-focus-inner,
button::-moz-focus-inner {
    padding: 0;
    border-style: none;
}
input[type='checkbox'],
input[type='radio'] {
    box-sizing: border-box;
    padding: 0;
}
input[type='date'],
input[type='datetime-local'],
input[type='month'],
input[type='time'] {
    -webkit-appearance: listbox;
}
textarea {
    overflow: auto;
    resize: vertical;
}
fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
}
legend {
    display: block;
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin-bottom: 0.5rem;
    font-size: 1.5rem;
    line-height: inherit;
    color: inherit;
    white-space: normal;
}
progress {
    vertical-align: baseline;
}
[type='number']::-webkit-inner-spin-button,
[type='number']::-webkit-outer-spin-button {
    height: auto;
}
[type='search'] {
    outline-offset: -2px;
    -webkit-appearance: none;
}
[type='search']::-webkit-search-cancel-button,
[type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
}
::-webkit-file-upload-button {
    font: inherit;
    -webkit-appearance: button;
}
output {
    display: inline-block;
}
summary {
    display: list-item;
    cursor: pointer;
}
template {
    display: none;
}
[hidden] {
    display: none !important;
}

.w-max {
    width: 1152px;
}

.w-max-strict {
    width: 1152px;
    min-width: 1152px;
    max-width: 1152px;
}

.card-response {
    width: 270px;
    height: 380px;
    min-width: 270px;
    min-height: 380px;
    max-width: 270px;
    max-height: 380px;
}

.card-grid-response {
    display: grid;
    grid-template-columns: repeat(4, 270px);
    gap: 24px;
}
/*Глобальные стили для кнопок в компетишене, которые просила Алёна) */
.comps-btn_white {
    font-family: "Inter";
    padding: 12px 32px 12px 24px;
    border: 1px solid #B6B6B5;
    border-radius: 3px;
    height: 48px;
    display: flex;
    place-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: transparent;
    transition: border 0.5s;
    white-space: pre;
}

.comps-btn_black {
    font-family: "Inter";
    padding: 12px 32px 12px 24px;
    color: #fff;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    border: 1px solid transparent;
    border-radius: 3px;
    height: 48px;
    display: flex;
    place-items: center;
    justify-content: center;
    cursor: pointer;
    letter-spacing: -0.02em;
    background-color: #151514;
    transition: background-color 0.5s;
    white-space: pre;
}

.comps-btn_white > * {
    color: #151514;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.02em;
}

.comps-btn_black > * {
    color: #fff;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.02em;
}

.comps-btn_black:hover, 
.comps-btn_black:focus,
.comps-btn_black:active {
    background-color: #1F1F1F;
    transition: background-color 0.5s;
}

.comps-btn_white:hover,
.comps-btn_white:focus,
.comps-btn_white:active {
    border: 1px solid #8E9193;
    transition: border 0.5s;
}

@media (max-width: 1280px) {
    .w-max {
        width: 940px;
    }

    .w-max-strict {
        width: 940px;
        min-width: 940px;
        max-width: 940px;
    }

    .card-response {
        width: 221.25px;
        height: 311.38px;
        min-width: 221.25px;
        min-height: 311.38px;
        max-width: 221.25px;
        max-height: 311.38px;
    }

    .card-grid-response {
        display: grid;
        grid-template-columns: repeat(4, 221.25px);
        gap: 19.6px;
    }
}

::-webkit-scrollbar {
    width: 10px; /* ширина scrollbar */
    height: 10px;
}
::-webkit-scrollbar-track {
    background: transparent; /* цвет дорожки */
}
::-webkit-scrollbar-thumb {
    border-radius: 3px; /* закругления плашки */
    background: rgba(0, 0, 0, 0.596);
    border: 1px solid rgba(254, 254, 254, 0.13);
}

.onlines-font {
    font-family: 'Space Grotesk', sans-serif !important;
}

.onlines-desc {
    font-family: 'Montserrat' !important;
}
`, "",{"version":3,"sources":["webpack://./src/core/starter/styles.css"],"names":[],"mappings":"AAAA;;;IAGI,sBAAsB;AAC1B;AACA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,8BAA8B;IAC9B,0BAA0B;IAC1B,6BAA6B;IAC7B,wCAAwC;AAC5C;AACA;IACI,uBAAuB;AAC3B;AACA;;;;;;;;;;IAUI,cAAc;AAClB;AACA;IACI,SAAS;IACT;oFACgF;IAChF,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,uBAAuB;IACvB,SAAS;IACT,iBAAiB;AACrB;AACA;;;;;;IAMI,aAAa;IACb,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;;IAEI,0BAA0B;IAC1B,yCAAyC;IACzC,iCAAiC;IACjC,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;;;IAGI,aAAa;IACb,mBAAmB;AACvB;AACA;;;;IAII,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;;IAEI,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;;IAEI,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,wBAAwB;AAC5B;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,6BAA6B;IAC7B,qCAAqC;AACzC;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;;IAEI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,UAAU;AACd;AACA;;;;IAII,iGAAiG;IACjG,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,6BAA6B;AACjC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,0CAA0C;AAC9C;AACA;;;;;IAKI,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;;IAEI,iBAAiB;AACrB;AACA;;IAEI,oBAAoB;AACxB;AACA;;;;IAII,0BAA0B;AAC9B;AACA;;;;IAII,UAAU;IACV,kBAAkB;AACtB;AACA;;IAEI,sBAAsB;IACtB,UAAU;AACd;AACA;;;;IAII,2BAA2B;AAC/B;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,UAAU;IACV,SAAS;IACT,SAAS;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,UAAU;IACV,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,wBAAwB;AAC5B;AACA;;IAEI,YAAY;AAChB;AACA;IACI,oBAAoB;IACpB,wBAAwB;AAC5B;AACA;;IAEI,wBAAwB;AAC5B;AACA;IACI,aAAa;IACb,0BAA0B;AAC9B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uCAAuC;IACvC,SAAS;AACb;AACA,qEAAqE;AACrE;IACI,oBAAoB;IACpB,4BAA4B;IAC5B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,6BAA6B;IAC7B,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,4BAA4B;IAC5B,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;;;IAGI,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;;;IAGI,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,oBAAoB;QACpB,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,0CAA0C;QAC1C,WAAW;IACf;AACJ;;AAEA;IACI,WAAW,EAAE,qBAAqB;IAClC,YAAY;AAChB;AACA;IACI,uBAAuB,EAAE,iBAAiB;AAC9C;AACA;IACI,kBAAkB,EAAE,uBAAuB;IAC3C,gCAAgC;IAChC,2CAA2C;AAC/C;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":["*,\n::after,\n::before {\n    box-sizing: border-box;\n}\nhtml {\n    font-family: sans-serif;\n    line-height: 1.15;\n    -webkit-text-size-adjust: 100%;\n    -ms-text-size-adjust: 100%;\n    -ms-overflow-style: scrollbar;\n    -webkit-tap-highlight-color: transparent;\n}\n@-ms-viewport {\n    /*width: device-width;*/\n}\narticle,\naside,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nnav,\nsection {\n    display: block;\n}\nbody {\n    margin: 0;\n    font-family: \"Inter\", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif,\n        'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #212529;\n    text-align: left;\n    background-color: #fff;\n}\n[tabindex='-1']:focus {\n    outline: 0 !important;\n}\nhr {\n    box-sizing: content-box;\n    height: 0;\n    overflow: visible;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    margin-top: 0;\n    margin-bottom: 0.5rem;\n}\np {\n    margin-top: 0;\n    margin-bottom: 1rem;\n}\nabbr[data-original-title],\nabbr[title] {\n    text-decoration: underline;\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n    cursor: help;\n    border-bottom: 0;\n}\naddress {\n    margin-bottom: 1rem;\n    font-style: normal;\n    line-height: inherit;\n}\ndl,\nol,\nul {\n    margin-top: 0;\n    margin-bottom: 1rem;\n}\nol ol,\nol ul,\nul ol,\nul ul {\n    margin-bottom: 0;\n}\ndt {\n    font-weight: 700;\n}\ndd {\n    margin-bottom: 0.5rem;\n    margin-left: 0;\n}\nblockquote {\n    margin: 0 0 1rem;\n}\ndfn {\n    font-style: italic;\n}\nb,\nstrong {\n    font-weight: bolder;\n}\nsmall {\n    font-size: 80%;\n}\nsub,\nsup {\n    position: relative;\n    font-size: 75%;\n    line-height: 0;\n    vertical-align: baseline;\n}\nsub {\n    bottom: -0.25em;\n}\nsup {\n    top: -0.5em;\n}\na {\n    color: #007bff;\n    text-decoration: none;\n    background-color: transparent;\n    -webkit-text-decoration-skip: objects;\n}\na:hover {\n    color: #0056b3;\n    text-decoration: none;\n}\na:not([href]):not([tabindex]) {\n    color: inherit;\n    text-decoration: none;\n}\na:not([href]):not([tabindex]):focus,\na:not([href]):not([tabindex]):hover {\n    color: inherit;\n    text-decoration: none;\n}\na:not([href]):not([tabindex]):focus {\n    outline: 0;\n}\ncode,\nkbd,\npre,\nsamp {\n    font-family: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;\n    font-size: 1em;\n}\npre {\n    margin-top: 0;\n    margin-bottom: 1rem;\n    overflow: auto;\n    -ms-overflow-style: scrollbar;\n}\nfigure {\n    margin: 0 0 1rem;\n}\nimg {\n    vertical-align: middle;\n    border-style: none;\n}\nsvg {\n    overflow: hidden;\n    vertical-align: middle;\n}\ntable {\n    border-collapse: collapse;\n}\ncaption {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n    color: #6c757d;\n    text-align: left;\n    caption-side: bottom;\n}\nth {\n    text-align: inherit;\n}\nlabel {\n    display: inline-block;\n    margin-bottom: 0.5rem;\n}\nbutton {\n    border-radius: 0;\n}\nbutton:focus {\n    outline: 1px dotted;\n    outline: 5px auto -webkit-focus-ring-color;\n}\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n    margin: 0;\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit;\n}\nbutton,\ninput {\n    overflow: visible;\n}\nbutton,\nselect {\n    text-transform: none;\n}\n[type='reset'],\n[type='submit'],\nbutton,\nhtml [type='button'] {\n    -webkit-appearance: button;\n}\n[type='button']::-moz-focus-inner,\n[type='reset']::-moz-focus-inner,\n[type='submit']::-moz-focus-inner,\nbutton::-moz-focus-inner {\n    padding: 0;\n    border-style: none;\n}\ninput[type='checkbox'],\ninput[type='radio'] {\n    box-sizing: border-box;\n    padding: 0;\n}\ninput[type='date'],\ninput[type='datetime-local'],\ninput[type='month'],\ninput[type='time'] {\n    -webkit-appearance: listbox;\n}\ntextarea {\n    overflow: auto;\n    resize: vertical;\n}\nfieldset {\n    min-width: 0;\n    padding: 0;\n    margin: 0;\n    border: 0;\n}\nlegend {\n    display: block;\n    width: 100%;\n    max-width: 100%;\n    padding: 0;\n    margin-bottom: 0.5rem;\n    font-size: 1.5rem;\n    line-height: inherit;\n    color: inherit;\n    white-space: normal;\n}\nprogress {\n    vertical-align: baseline;\n}\n[type='number']::-webkit-inner-spin-button,\n[type='number']::-webkit-outer-spin-button {\n    height: auto;\n}\n[type='search'] {\n    outline-offset: -2px;\n    -webkit-appearance: none;\n}\n[type='search']::-webkit-search-cancel-button,\n[type='search']::-webkit-search-decoration {\n    -webkit-appearance: none;\n}\n::-webkit-file-upload-button {\n    font: inherit;\n    -webkit-appearance: button;\n}\noutput {\n    display: inline-block;\n}\nsummary {\n    display: list-item;\n    cursor: pointer;\n}\ntemplate {\n    display: none;\n}\n[hidden] {\n    display: none !important;\n}\n\n.w-max {\n    width: 1152px;\n}\n\n.w-max-strict {\n    width: 1152px;\n    min-width: 1152px;\n    max-width: 1152px;\n}\n\n.card-response {\n    width: 270px;\n    height: 380px;\n    min-width: 270px;\n    min-height: 380px;\n    max-width: 270px;\n    max-height: 380px;\n}\n\n.card-grid-response {\n    display: grid;\n    grid-template-columns: repeat(4, 270px);\n    gap: 24px;\n}\n/*Глобальные стили для кнопок в компетишене, которые просила Алёна) */\n.comps-btn_white {\n    font-family: \"Inter\";\n    padding: 12px 32px 12px 24px;\n    border: 1px solid #B6B6B5;\n    border-radius: 3px;\n    height: 48px;\n    display: flex;\n    place-items: center;\n    justify-content: center;\n    cursor: pointer;\n    background-color: transparent;\n    transition: border 0.5s;\n    white-space: pre;\n}\n\n.comps-btn_black {\n    font-family: \"Inter\";\n    padding: 12px 32px 12px 24px;\n    color: #fff;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    border: 1px solid transparent;\n    border-radius: 3px;\n    height: 48px;\n    display: flex;\n    place-items: center;\n    justify-content: center;\n    cursor: pointer;\n    letter-spacing: -0.02em;\n    background-color: #151514;\n    transition: background-color 0.5s;\n    white-space: pre;\n}\n\n.comps-btn_white > * {\n    color: #151514;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: -0.02em;\n}\n\n.comps-btn_black > * {\n    color: #fff;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: -0.02em;\n}\n\n.comps-btn_black:hover, \n.comps-btn_black:focus,\n.comps-btn_black:active {\n    background-color: #1F1F1F;\n    transition: background-color 0.5s;\n}\n\n.comps-btn_white:hover,\n.comps-btn_white:focus,\n.comps-btn_white:active {\n    border: 1px solid #8E9193;\n    transition: border 0.5s;\n}\n\n@media (max-width: 1280px) {\n    .w-max {\n        width: 940px;\n    }\n\n    .w-max-strict {\n        width: 940px;\n        min-width: 940px;\n        max-width: 940px;\n    }\n\n    .card-response {\n        width: 221.25px;\n        height: 311.38px;\n        min-width: 221.25px;\n        min-height: 311.38px;\n        max-width: 221.25px;\n        max-height: 311.38px;\n    }\n\n    .card-grid-response {\n        display: grid;\n        grid-template-columns: repeat(4, 221.25px);\n        gap: 19.6px;\n    }\n}\n\n::-webkit-scrollbar {\n    width: 10px; /* ширина scrollbar */\n    height: 10px;\n}\n::-webkit-scrollbar-track {\n    background: transparent; /* цвет дорожки */\n}\n::-webkit-scrollbar-thumb {\n    border-radius: 3px; /* закругления плашки */\n    background: rgba(0, 0, 0, 0.596);\n    border: 1px solid rgba(254, 254, 254, 0.13);\n}\n\n.onlines-font {\n    font-family: 'Space Grotesk', sans-serif !important;\n}\n\n.onlines-desc {\n    font-family: 'Montserrat' !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
